module.exports = __webpack_public_path__ + "static/media/number_col_company.0c071207.jpg";